









import React from "react";
import "../../styles/IndianSteelExpress.css";
import steelImage from "../../images/steel-slider.jpg"; // Update with correct path
import steel1 from "../../assets/steel1.jpg"; // Update with correct path
import steel2 from "../../assets/steel2.jpg"; // Update with correct path
import steelIcon from "../../assets/service-icon.png"; // Import the steel icon
import { Link } from "react-router-dom";

const IndianSteelExpress = () => {
  return (
    <div className="steel-container">
      {/* Image Slider - Full width like homepage */}
      <div className="steel-image-slider">
        <img src={steelImage} alt="Indian Steel Express Slider" />
      </div>

      {/* Main Content Container */}
      <div className="steel-content">
        {/* Content Card with title inside */}
        <div className="steel-card">
          {/* Title with Icon - Added with blue style */}
          <div className="steel-title-header">
            <img src={steelIcon} alt="Steel Service" className="steel-title-icon rotate-on-hover" />
            <h3 className="steel-title-text">Indian Steel Express</h3>
          </div>
          
          {/* Left Side - Images */}
          <div className="card-left">
            <div className="steel-image-container first-image">
              <img src={steel1} alt="Steel Loading" className="steel-img" />
            </div>
            <div className="steel-image-container second-image">
              <img src={steel2} alt="Steel Transport" className="steel-img" />
            </div>
          </div>

          {/* Right Side - Text Content */}
          <div className="card-right">
            <p className="steel-text">
              India has emerged to be amongst the largest steel producing nations in the world, and has also
              seen a corresponding growth in exports of these products to various global markets worldwide.
            </p>
            <p className="steel-text">
              Puyvast has been associated with these exports since its inception, and over the past few decades
              has catered to the requirements of almost all major steel manufacturers and traders, to destinations
              in South East Asia, Europe, Scandinavia, UK, Africas, Mexico, USA & Canada.
            </p>
            <p className="steel-text">
              Puyvast vessels are ideally structured and suitably geared to load steel products, which together
              with Puyvast's range of specialized equipment to handle plates, coils, billets, blooms, and slabs,
              provides a safe and reliable transport to the steel industry.
            </p>
          </div>
        </div>
      </div>

      {/* Footer - Same as homepage */}
      <footer className="footer">
        <div className="footer-container">
          {/* Left Section - CIN & Links */}
          <div className="footer-left">
            <p>CIN Number: U63030KA2022PTC161825</p>
            <p>
              <Link to="/privacy-statement" className="footer-link">Privacy Statement</Link> |
              <Link to="/terms-of-use" className="footer-link"> Terms Of Use</Link>
            </p>
          </div>

          {/* Center - Copyright */}
          <div className="footer-center">
            <p>© {new Date().getFullYear()} ONEVEGA Systems (India) Pvt Ltd.</p>
          </div>

          {/* Right Section - Registered Office */}
          <div className="footer-right">
            <p><strong>Registered Office</strong></p>
            <p>Puyvast Logistics Pvt. Ltd.</p>
            <p>PuyVast House </p>
            <p>4th Floor ,#6, Harris Road, Benson Town,<br></br> Bangalore - 560 046.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default IndianSteelExpress;